import { ResultResponse } from './ResultResponse'

export type NoContentResponse = ''

export interface NoContentResult extends ResultResponse<NoContentResponse> {}
